import { defineRule } from 'vee-validate'
import parseMobile from 'libphonenumber-js/mobile'
import { i18n } from '@/i18n.js'

defineRule('checkValidMobilePhoneNumber', (value, args) => {
  if (args[0] !== null) {
    const number = parseMobile(args[0] + value)
    if (number !== '' && typeof number !== 'undefined' && number !== null) {
      return number && number.isValid() && number.getType() === 'MOBILE'
        ? true
        : i18n.global.t('errors.mobilePhoneNotValid')
    } else {
      return true
    }
  } else {
    return true
  }
})
